import { useState, useEffect } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
// import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { useNavigate } from "react-router-dom";
import { useSearchParams, useLocation } from 'react-router-dom'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import { getReviewContent, approveReviewContent, clearApiResponseStatusAction, getReplaceContent, GetRadioSelectedAction } from "../../redux/Actions/PowerDataQuery";
import DevOpsUIConfirmDialog from '../CustomDialog/DevOpsUIConfirmDialog'
import { IAutoHealingSubmitPayload } from '../Interface/Params/IAutoHealingPayload'
import { MessageBar } from '@fluentui/react';
import {  useMsal, useAccount } from "@azure/msal-react";
import { RemediationUsers } from '../../ConfigData/RemediationUsers'
import ErrorDialog from '../CustomDialog/ErrorDialog'
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import {  MessageBarType } from 'office-ui-fabric-react'
import { SubtractUtcTimes, convertUtcToPst } from '../Utilities/CommonFunction'
import ReplaceDialog from '../ReplaceDialog/ReplaceDialog';
import { Stack } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ChoiceGroup, IChoiceGroupOption, IChoiceGroupStyles } from '@fluentui/react/lib/ChoiceGroup';

import './TextCrawlerFixer.css'
import { IAutoHealingReplacement } from '../Interface/View/IAutoHealingView';
import CustomOperationGroup from '../Modules/CommonPageContent/CustomOperationGroup/CustomOperationGroup';
import CustomTabBar from '../Modules/CommonPageContent/CustomTabBar/CustomTabBar';
// import { Observer } from "azure-devops-ui/Observer";
import XmlDiffEditor from '../Modules/XmlDiffEditor/XmlDiffEditor';

const actionCreators = {
    getReviewContent,
    approveReviewContent,
    clearApiResponseStatusAction,
    getReplaceContent,
    GetRadioSelectedAction
  };
  
  type DispatchProps = typeof actionCreators;
  
  const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContent: state.reviewContent,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected
  });
  
const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

// // Curation area RadioButton
// let FixRadioButton = new ObservableValue<string>("Approve");

// Confirm dialog form state interface
interface IConfirmDialogState {
    showDialog: boolean,
}

// Replace dialog form state interface
interface IReplaceState {
    showDialog: boolean
}

// Error dialog form state interface
interface IErrorState {
    title: string,
    showDialog: boolean,
    errorMessage: string,
    errorDetail: string,
    errorCategory?: "InputError" | "SystemError" | "UnknownError",
    messageBarType: MessageBarType
}

// const selectedTabId = new ObservableValue('')

/**
 * broken link checker
 * @param props 
 * @returns 
 */
function TextCrawlerFixer(props: StoreProps & DispatchProps) {
    const { accounts } = useMsal();
    const userAccount = useAccount(accounts[0]);

    // get the url from the query string
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const traceID = search.get('traceID')
    const curationID = search.get('curationID')
    const pathArr = useLocation().pathname.split('/')
    // const jobID = search.get('JobID')

    // set the healing complete params
    let healingCompleteParams: IHealingCompleteParams = {
        reviewType: "",
        fixerPath: pathArr[pathArr.length-1],
        requesturl: requesturl,
        traceID: traceID,
        curationID: curationID,
        completeTitle: "Thank you!",
        actionLink: [],
    }

    const history = useNavigate();

    /** Initialize confirm dialog form state */
    const [confirmDialogState, setConfirmDialogState] = useState<IConfirmDialogState>({
        showDialog: false
    })

    /** Initialize error dialog form state */
    const [errorDialogState, setErrorDialogState] = useState<IErrorState>({
        title: "",
        showDialog: false,
        errorMessage: "",
        errorDetail: "",
        messageBarType: MessageBarType.error
    })

    /** Initialize confirm dialog form state */
    const [replaceDialogState, setReplaceDialogState] = useState<IReplaceState>({
        showDialog: false
    })

    /** Initialize editor data state */
    const [newDiffEditorData, SetNewDiffEditorData] = useState<string>("");
    const [newNavigationDiffEditorData, SetNewNavigationDiffEditorData] = useState<string>("");
    const [newMetaDiffEditorData, SetNewMetaDiffEditorData] = useState<string>("");

    /** Initialize loading state */
    const [isLoading, setIsLoading] = useState<boolean>(false)

    /** Initialize loading replace button state */
    const [showReplaceButton, setShowReplaceButton] = useState<boolean>(false)

    /**
     * Tab bar related
     */
    const [tabGroupNames, setTabGroupNames] = useState<string[]>(['Content'])

    const [FixRadioButton, setFixRadioButton] = useState<string>("Approve")
    const [selectedTabId, setSelectedTabId] = useState<string>("")

    const [radioGroupValue, setRadioGroupValue] = useState<string>(null)
    const [radioOptions, setRadioOptions] = useState([])
    const [radioPermissionOptions, setRadioPermissionOptions] = useState([])
    
    /**
     * Get the content from the api
     */
    useEffect(() => {
        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

        // Load data from API in effect
        const loadData = async () => {
            setIsLoading(true)

            // call the api to get the content
            await props.getReviewContent(requesturl, traceID, curationID);

            setIsLoading(false)
        }

        loadData();
    }, [])

    /**
     * handle review content change
     */
    useEffect(() => {
        if (props.reviewContent) {
            // When no broken links are detected, redirect to the completion page.
            if (!props.reviewContent?.AutoChangeSummaryHtml || props.reviewContent?.AutoChangeSummaryHtml?.length == 0) {
                healingCompleteParams.reviewType = 'TextCrawler'
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }

            // init tab
            const tabSet = new Set<string>()

            if(props.reviewContent?.NavOriginalText) {
                tabSet.add('Navigation')
                SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            }
            if(props.reviewContent?.OriginalText) {
                tabSet.add('Content')
                SetNewDiffEditorData(props.reviewContent.ChangedText)
            }
            if(props.reviewContent?.MetaOriginalText) {
                tabSet.add('Metadata')
                SetNewMetaDiffEditorData(props.reviewContent.MetaChangedText)
            }

            setTabGroupNames(Array.from(tabSet))

            // When the user fixes broken links through autohealing tool and the time for repair has not exceeded 30 minutes, redirect to the completion page.            
            const approveUtcTime = props.reviewContent?.ReviewHistory?.ReviewDate;
            const reviewResult = props.reviewContent.ReviewHistory?.ReviewResult;
            if (approveUtcTime && (props.reviewContent.ReviewHistory?.ReviewResult === 3 || props.reviewContent.ReviewHistory?.ReviewResult === 4)) {
                const durationUtcTime = SubtractUtcTimes(approveUtcTime)
                if (durationUtcTime < 30) {
                    healingCompleteParams.reviewType = 'TextCrawler'
                    healingCompleteParams.completeTitle = "Thank you!"
                    if (props.reviewContent.ReviewHistory?.ReviewResult === 3) {
                        healingCompleteParams.actionLink = props.reviewContent?.ActionLink
                    }
                    history(`/apps/close`, { state: healingCompleteParams })
                }
            }

            if (props.reviewContent.ReviewHistory?.ReviewResult === 2) {
                healingCompleteParams.reviewType = 'ManuallyFix'
                healingCompleteParams.completeTitle = "Thank you!"
                healingCompleteParams.actionLink = props.reviewContent?.ActionLink
                history(`/apps/close`, { state: healingCompleteParams })
            }

            // No permission to access the page
            if (!isRemediationUser()) {
                healingCompleteParams.reviewType = 'NoPermission'
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }

            // Set the review result
            if (reviewResult === 1) {
                // FixRadioButton.value = "Exception";
                setFixRadioButton("Exception")
            }
            else if (reviewResult === 2) {
                // FixRadioButton.value = "ManuallyFix";
                setFixRadioButton("ManuallyFix")
            }
            else if (reviewResult === 4) {
                // FixRadioButton.value = "Replace";
                setFixRadioButton("Replace")
                setShowReplaceButton(true);
            }
            else {
                // FixRadioButton.value = "Approve";
                setFixRadioButton("Approve")
            }

            var options = [];
            var permissionOptions = [];
            props.reviewContent?.ActionLink?.map((item: any, index: any) => {
                if (item.HavePermission) {
                    options.push({ key: index.toString(), text: item.Name })
                } else {
                    permissionOptions.push({ key: index.toString(), text: item.Name })
                }
            });
            if (options.length > 0) {
                setRadioGroupValue(options[0].key)
            }
            setRadioOptions(options)
            setRadioPermissionOptions(permissionOptions)

        }
    }, [props.reviewContent])

    useEffect(() => {
        if (props.replaceContent) {
            if(FixRadioButton === "Replace"){
                SetNewDiffEditorData(props.replaceContent.ReplacementChangedText)
                SetNewMetaDiffEditorData(props.replaceContent.MetaReplacementChangedText)
                SetNewNavigationDiffEditorData(props.replaceContent.ReplacementNavChangedText)
            }else if(FixRadioButton === "Approve"){
                SetNewDiffEditorData(props.reviewContent.ChangedText)
                SetNewMetaDiffEditorData(props.reviewContent.MetaChangedText)
                SetNewNavigationDiffEditorData(props.reviewContent.NavChangedText)
            }
        }
    }, [props, props.replaceContent])
    

    /**
     * handle api response change
     */
    useEffect(() => {
        if (props.apiResponseState && props.apiResponseState?.showErrorDailog) {
            const errorTitle = props.apiResponseState.ErrorMessage? 'Error': 'Application Error'
            setErrorDialogState({
                title: errorTitle,
                showDialog: true,
                errorMessage: `We were unable to get the content you requested due to an internal server error. Please retry your action or try again later. Error:${props.apiResponseState?.ErrorMessage}`,
                errorDetail: props.apiResponseState?.ErrorMessage,
                messageBarType: MessageBarType.error
            })
        }

    }, [props.apiResponseState])

    /**
     * check if the confirm button is disabled
     * @returns 
     */
    function isConfirmButtonDisabled() {
        // if call api error, disable the confirm button
        if (props.apiResponseState?.ErrorMessage?.length > 0) {
            return true;
        }

        // if auto change summary is empty, disable the confirm button
        if (props.reviewContent?.AutoChangeSummaryHtml?.length <= 0) {
            return true;
        }

        if (!isRemediationUser()) {
            return true;
        }

        return false;
    }

    /**
     * Set the approve area RadioButtons value
     * @param buttonId radio button id
     */
    function onFixOptionSelect(buttonId: string) {
        // FixRadioButton.value = buttonId;
        setFixRadioButton(buttonId)
        if(buttonId === "Replace")
        {
            setShowReplaceButton(true);
            setReplaceDialogState({
                showDialog: true
            })
        }else{
            setShowReplaceButton(false);
            setReplaceDialogState({
                showDialog: false
            })
        }

        props.GetRadioSelectedAction(buttonId);
    };

    /**
     * Handle replace click
     */
    function handleReplaceClick() {
        if (FixRadioButton === "Replace") {
            setReplaceDialogState({
                showDialog: true
            })
        } 
    }

    /**
     * Handle confirm click
     */
    function handleConfirmClick() {
        // "I approve this change. Publish the updated file and resolve this ticket." selected
        if (FixRadioButton === "Approve" || FixRadioButton === "Replace") {
            setConfirmDialogState({
                showDialog: true
            })
        } else {
            // Submit the changes.
            SubmitChange()

            if (FixRadioButton == "ManuallyFix") {

                setTimeout(() => {
                    window.location.href = props.reviewContent?.ActionLink[radioGroupValue].Url;
                }, 2500);

            } else {
                healingCompleteParams.reviewType = FixRadioButton
                healingCompleteParams.completeTitle = "Thank you!"
                history(`/apps/close`, { state: healingCompleteParams })
            }
        }
    }

    /**
     * Handle the diff editor change
     * @param value 
     */
    function onDiffEditorChange(type: string, value: string) {
        if(type === 'Navigation') {
            SetNewNavigationDiffEditorData(value)
        }
        if(type === 'Content') {
            SetNewDiffEditorData(value)
        }
        if(type === 'Metadata') {
            SetNewMetaDiffEditorData(value)
        }
    }

    /**
     * handle the confirm dialog dismiss
     */
    function onConfirmDialogDismiss() {
        setConfirmDialogState({
            showDialog: false
        })
    }

    /**
     * handle the replace dialog dismiss
     */
    function onReplaceDialogDismiss() {
        setReplaceDialogState({
            showDialog: false
        })
    }

    /**
     * handle the error dialog dismiss
     */
    function onErrorDialogDismiss() {
        //props.clearApiResponseStatusAction()
        setErrorDialogState({
            ...errorDialogState,
            showDialog: false
        })

        healingCompleteParams.reviewType = "Close"
        healingCompleteParams.completeTitle = "Thank you!"
        history(`/apps/close`, { state: healingCompleteParams })
    }

    /**
     * handle the confirm dialog submit
     */
    function SubmitChange() {
        const reason = arguments.length>0 ?arguments[0]:'';
        let reviewResult = 1;
        if (FixRadioButton === "ManuallyFix") {
            reviewResult = 2;
        }
        else if (FixRadioButton === "Approve") {
            reviewResult = 3;
        }else if (FixRadioButton === "Replace") {
            reviewResult = 4;
        }

        // submit the changes
        let approveParams: IAutoHealingSubmitPayload = {
            KBID: props.reviewContent?.KBID,
            RepoId: props.reviewContent?.RepoId,
            DdueContent: newDiffEditorData,
            NavJsonContent: newNavigationDiffEditorData,
            MetaContent: newMetaDiffEditorData,
            OriginalMetaContent: props.reviewContent?.MetaOriginalText,
            OriginalNavJsonContent: props.reviewContent?.NavOriginalText,
            NavC3FilePath: props.reviewContent?.NavC3FilePath,
            NavMetadataFilePath: props.reviewContent?.NavMetadataFilePath,
            NavRepoId: props.reviewContent?.NavRepoId,
            OriginalDdueContent: props.reviewContent?.OriginalText,
            Link: props.reviewContent?.Link,
            TraceID: props.reviewContent?.TraceID,
            OrganizationName: props.reviewContent?.OrganizationName,
            ProjectName: props.reviewContent?.ProjectName,
            TicketId: props.reviewContent?.TicketId,
            CurationID: props.reviewContent?.CurationID,
            JobID: props.reviewContent?.JobID,
            TicketCreatedDate: props.reviewContent?.TicketCreatedDate,
            ReviewResult: reviewResult,
            Reason: reason? reason:"Auto-Healing",
            ChangeHistoryOrNot: reason? true: false,
            C3FilePath: props.reviewContent?.C3FilePath,
            MetadataFilePath: props.reviewContent?.MetadataFilePath,
            RequiredAlias: props.reviewContent?.RequiredAlias,
            OptionalAlias: props.reviewContent?.OptionalAlias,
            ManagerAlias: props.reviewContent?.ManagerAlias,
            AutoHealingType: props.reviewContent?.AutoHealingType
        }

        props.approveReviewContent(approveParams);

        if (FixRadioButton === "Approve" || FixRadioButton === "Replace") {
            setConfirmDialogState({
                showDialog: false
            })

            healingCompleteParams.reviewType = FixRadioButton
            healingCompleteParams.completeTitle = "Congratulations!"
            history(`/apps/close`, { state: healingCompleteParams })
        }
    }

    /**
     * check if the user is in the remediation user list
     * @returns 
     */
    function isRemediationUser() {
        let userExsit = RemediationUsers.find((userItem) => userItem.userName === userAccount.username)
        if (userAccount.username !== props.reviewContent?.RequiredAlias &&
            userAccount.username !== props.reviewContent?.OptionalAlias &&
            userAccount.username !== props.reviewContent?.ManagerAlias &&
            !userExsit) {
            return false;
        }

        return true;
    }

    /**
     * handle the cancel click
     */
    function handCancelClick() {
        healingCompleteParams.reviewType = "Close"
        healingCompleteParams.completeTitle = "Thank you!"
        history(`/apps/close`, { state: healingCompleteParams })
    }

    async function replaceChange(replacementContent: IAutoHealingReplacement) {
        try {
          setIsLoading(true);
          await props.getReplaceContent(replacementContent);
          setIsLoading(false);
        } catch (error) {
          console.error("API Error:", error);
        }
    }

    /**
     * render the review history
     * @returns 
     */
    function renderReviewHistory() {
        if (!props.reviewContent || !props.reviewContent?.ReviewHistory) {
            return null;
        }

        const { Reviewer, ReviewDate } = props.reviewContent?.ReviewHistory;

        let message: string = "";
        switch (props.reviewContent?.ReviewHistory?.ReviewResult) {
            // Exception
            case 1:
                message = `${Reviewer} has not approved the changes and does not want any action to be taken on this article on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // ManuallyFix
            case 2:
                message = `${Reviewer} will work on the issue manually and does not want any automated changes to be made at this time on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // Approve
            case 3:
                message = `${Reviewer} has approved the changes to republish the article and close this ticket on ${convertUtcToPst(ReviewDate)}.`;
                break;
            // Replace
            case 4:
                message = `${Reviewer} has approved the changes to republish the article and close this ticket on ${convertUtcToPst(ReviewDate)}.`;
                break;
        }

        return (
            <>
                <MessageBar
                    messageBarType={MessageBarType.warning}
                    isMultiline={false}
                    className="autohealing-review-history"
                    styles={{
                        root: {
                            backgroundColor: '#fff4ce',
                            borderRadius: 6,
                            boxShadow: '0 1.6px 3.6px rgba(0,0,0,0.132), 0 0.3px 0.9px rgba(0,0,0,0.108)',
                            padding: '12px 16px',
                            fontSize: 14,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                        },
                        icon: {
                            fontSize: 16,
                        },
                        text: {
                            lineHeight: '20px',
                        }
                    }}
                >
                    {message}
                </MessageBar>
                <div className="flex-grow">
                    <br />
                </div>
            </>
        );
    }

    const buildOperationGroupConfig = () => {
        const flag = !isRemediationUser()
        return [
            {
                disabled: flag,
                id: 'Approve',
                text: 'Yes, I want to resolve the issue and agree with the proposed change to replace the identified text with a pre-configured text. Automatically pull the article files, apply and merge the change, republish the article, and resolve this ticket with all applicable actions recorded.'
            },
            {
                disabled: flag,
                id: 'Replace',
                text: 'Yes, I want to resolve the issue by personally substituting the text with a functional one. Open the relevant content replacement canvas.',
                child: <PrimaryButton primary={showReplaceButton} text="Replace the incorrect content" onClick={handleReplaceClick} disabled={!showReplaceButton}/>
            },
            {
                disabled: flag,
                id: 'ManuallyFix',
                text: 'Yes, I want to resolve the issue but not in the way proposed. Open it in the relevant authoring canvas.',
                edittingDiv: <div style={{ marginLeft: 28, marginTop: 0, marginBottom: 10 }}>
                    <div style={{ margin: "10px 0px 0px 15px", fontWeight: "700" }}>
                        <div>
                            Editting in{' '}
                            <span style={{ fontWeight: "500" }}>
                                (For author only)
                            </span>
                        </div>
                        <div className='radioGroup'>
                            <ChoiceGroup selectedKey={radioGroupValue} options={radioOptions} onChange={_onChange} label="" />
                        </div>

                        {
                            radioPermissionOptions.length > 0 ?
                                <div>
                                    <div style={{ marginTop: "10px" }}>
                                        Submit change request through{' '}
                                        <span style={{ fontWeight: "500" }}>
                                            (For individuals who don't have the author permission)
                                        </span>
                                    </div>
                                    <div className='permissionRadio'>
                                        <ChoiceGroup selectedKey={radioGroupValue} options={radioPermissionOptions} onChange={_onChange} label="" />
                                    </div>
                                </div> : null
                        }
                    </div>
                </div>
            },
            {
                disabled: flag,
                id: 'Exception',
                text: 'No, I do not want to resolve this content-quality issue. Take no further action on this article and resolve this ticket. (Please note that your decision to leave this issue in the article will be recorded.)'
            }
        ]
    }

    function _onChange(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
        setRadioGroupValue(option.key)
    }

    return (
        <div style={{ width: "100%", overflowY: "scroll", height: "100vh" }}>
            <div className="flex-grow">
                <br />
            </div>
            {/* <Surface background={SurfaceBackground.neutral}> */}
                {/* <Page className="pipelines-page"> */}
                <Stack className="pipelines-page" style={{backgroundColor:"rgba( var(--palette-neutral-2,248, 248, 248) ,  1 )"}} tokens={{ childrenGap: 16 }} styles={{ root: { padding: 16 } }}>

                    <div className="page-content page-content-top">
                        {
                            tabGroupNames.length>1 ?
                            <>
                                <CustomTabBar
                                    tabGroupNames={tabGroupNames}
                                    onSelectChange={ tabId => setSelectedTabId(tabId) }
                                />
                                <Stack tokens={{ childrenGap: 8 }} className="customCard">
                                    <XmlDiffEditor
                                        type={selectedTabId}
                                        onDiffEditorChange={onDiffEditorChange}
                                        selectedResult={FixRadioButton}
                                    />
                                </Stack>
                                {/* <Observer selectedTabId={selectedTabId}>
                                    {(props: { selectedTabId: string }) => {
                                        return (
                                            <Stack tokens={{ childrenGap: 8 }} className="customCard">
                                                <XmlDiffEditor type={props.selectedTabId} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton}/>
                                            </Stack>
                                        )
                                    }}
                                </Observer> */}
                            </>:
                            <Stack tokens={{ childrenGap: 8 }} className="customCard">
                                <XmlDiffEditor type={tabGroupNames[0]} onDiffEditorChange={onDiffEditorChange} selectedResult={FixRadioButton}/>
                            </Stack>
                        }
                      
                        {renderReviewHistory()}

                        <CustomOperationGroup
                            selectedButtonId={FixRadioButton}
                            onSelect={onFixOptionSelect}
                            groupConfig={buildOperationGroupConfig()}
                        />
                        {/* <Card>
                            <div>
                                <ButtonGroup className="flex-wrap">
                                    <Button text="Confirm"
                                        primary={true}
                                        disabled={isConfirmButtonDisabled()}
                                        onClick={handleConfirmClick} />
                                    <Button text="Close" onClick={handCancelClick} />
                                </ButtonGroup>
                            </div>
                        </Card> */}
                        <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ marginBottom: "50px" }}>
                            <div>
                                <Stack horizontal wrap tokens={{ childrenGap: 8 }}>
                                    <PrimaryButton
                                        text="Confirm"
                                        onClick={handleConfirmClick}
                                        disabled={isConfirmButtonDisabled()}
                                    />
                                    <DefaultButton
                                        text="Close"
                                        onClick={handCancelClick}
                                    />
                                </Stack>
                            </div>
                        </Stack>
                        <div className="flex-grow" style={{ marginBottom: "10px" }}>
                            <br />
                        </div>
                    </div>
                </Stack>
                {/* </Page> */}
            {/* </Surface> */}
            <>
              {showReplaceButton &&  
              <ReplaceDialog
                    title={'Replace the incorrect content'}
                    replaceContent={props.replaceContent}
                    reviewContent={props.reviewContent}
                    showDialog={replaceDialogState.showDialog}
                    onReplaceDialogDismiss={onReplaceDialogDismiss}
                    onReplaceDialogApply={replaceChange}
                    algorithmType='TextClawer'
                />} 
                <DevOpsUIConfirmDialog
                    title={'Confirmation'}
                    content='You are about to approve this change, click Approve, it will publish the change and resolve the ticket.'
                    ccid={props.reviewContent?.CIID}
                    showDialog={confirmDialogState.showDialog}
                    onConfirmDialogDismiss={onConfirmDialogDismiss}
                    onConfirmDialogSubmit={SubmitChange}
                />
                <ErrorDialog
                    title={errorDialogState.title}
                    errorMessage={errorDialogState.errorMessage}
                    // showErrorDialog={props.apiResponseState?.showErrorDailog}
                    showErrorDialog={errorDialogState.showDialog}
                    apiUrl={props.apiResponseState?.ApiUrl}
                    detailErrorMessage={errorDialogState.errorDetail}
                    messageBarType={errorDialogState.messageBarType}
                    onErrorDialogDismiss={onErrorDialogDismiss}
                />
                {
                    isLoading && <Spinner className='autohealing-loading' label='Loading...' size={SpinnerSize.large} />
                }
            </>
        </div>
    )
}

export default connect<StoreProps, DispatchProps>(
  mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(TextCrawlerFixer);
